// proxy経由によるカスタムアプリエンドポイントへのアクセス
// "/apps/grapht-custom-app-proxy"の部分がカスタムアプリのホストにShopify側で置き換えられる
const hostname = location.hostname
let backendBaseUri = "/apps/grapht-custom-app-proxy/api/v1/shopifyApp/"

// 開発環境の場合
if (hostname === 'dev-grapht-store.myshopify.com') {
    backendBaseUri = "/apps/grapht-custom-app-dev-proxy/api/v1/shopifyApp/"
}
const backendEndPoint = (path) => backendBaseUri.concat(path)

class CartPoint extends HTMLElement {
    constructor() {
        super()
    }

    cartUpdateUnsubscriber = undefined

    // ポイント更新処理の排他制御用 (refreshPoints() 参照)
    refreshingPoints = false
    scheduledRefreshingPoints = false

    connectedCallback() {
        this.refreshPoints()

        if (window.subscribe) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                this.onCartUpdated()
            })
        }
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber()
        }
    }

    // pubsub が有効であれば自動的に呼ばれる (connectedCallback() 参照)
    // そうでない場合はカートの内容が変更された時に明示的にこの method を呼ぶ必要がある。
    onCartUpdated() {
        this.refreshPoints()
    }

    refreshPoints() {
        if (this.refreshingPoints) {
            this.scheduledRefreshingPoints = true
            return
        }
        else {
            this._refreshPoints().then(r => {
                try {
                    if (this.scheduledRefreshingPoints) {
                        this.scheduledRefreshingPoints = false
                        this.refreshPoints()
                    }
                }
                finally {
                    this.updatePoints(r.grantingPoints)
                }
            })
        }
   }

    async _refreshPoints() {
        this.refreshingPoints = true
        this.updatePoints("計算中")
        try {
            const cartData = await fetch(window.Shopify.routes.root + "cart.js").then(r => r.json())
            const pointData = await fetch(backendEndPoint("getGrantingPoints"), {
                method: "POST",
                body: JSON.stringify({context: "cart", cartData}),
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(r => r.json())

            return pointData
        } finally {
            this.refreshingPoints = false
        }
    }

    updatePoints(value) {
        //this.innerText = value;
        this.innerText = value == "計算中" ? value : Number(value).toLocaleString();
    }
}

customElements.define('cart-point', CartPoint);

